import {formatNumber} from '@angular/common';
import {Pipe, PipeTransform, inject} from '@angular/core';
import {LocaleService} from '../../translation/services/locale.service';

@Pipe({
  name: 'localizedNumber',
  pure: false
})
export class LocalizedNumberPipe implements PipeTransform {
  private readonly localeService = inject(LocaleService);

  transform(
    value: string | number | null | undefined,
    digitsInfo?: string,
  ): string | null {
    if (value === null || value === undefined) {
      return null;
    }

    return formatNumber(Number(value), this.localeService.userLanguage, digitsInfo);
  }
}
